import { IMPREZA_BUTTON_PROPS } from "../components/provider.js";
import { __ } from "../utils/i18n.js";
/**
 * @see https://ant.design/components/modal/#Modal.method()
 */ function providedModal(type, children, modal, options = {}) {
    const modalInstance = modal[type]({
        okText: type === "confirm" ? __("OK") : __("Close"),
        cancelText: type === "confirm" ? __("Cancel") : __("Close"),
        okButtonProps: {
            ...IMPREZA_BUTTON_PROPS
        },
        ...options
    });
    modalInstance.update({
        content: typeof children === "function" ? children(modalInstance) : children
    });
    return modalInstance;
}
export { providedModal };
